import {
  instance as axios,
  setJwtToken,
  // setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------For Product Component--------------------------

export const productListApi = async (data) => {
  const endPoint = `/admin/product?${new URLSearchParams({
    ...data,
  })}`;

  return await axios.get(endPoint, setJwtToken());
};
// -------------delete

export const deleteProductApi = async (id) => {
  const endPoint = `/admin/product/${id}`;

  return await axios.delete(endPoint, setJwtToken());
};
// -------------delete-product-image------------
export const deleteProductImageApi = async (data) => {
  const endPoint = `/admin/product/delete/image`;
  return await axios.post(endPoint, data, setJwtToken());
};
// -----------add new product
export const addNewProductApi = async (data) => {
  const endPoint = `/admin/product`;

  return await axios.post(endPoint, data, setJwtToken());
};

// -----------EDIT SELECTED  product
export const editSelectedProductApi = async ({ id, data }) => {
  const endPoint = `/admin/product/${id}`;

  return await axios.put(endPoint, data, setJwtToken());
};

export const editProductApi = async ({ id, data }) => {
  const endPoint = `/admin/product/${id}`;

  return await axios.put(endPoint, data, setJwtToken());
};


// ----------fetch selected product Product detail
export const selectedProductDetailApi = async (id) => {
  const endPoint = `/admin/product/${id}`;

  return await axios.get(endPoint, setJwtToken());
};

// ---------------------For Product-type Component--------------------------

export const productTypeListApi = async (data) => {
  const endPoint = `/admin/product/type?${new URLSearchParams({
    ...data,
  })}`;

  return await axios.get(endPoint, setJwtToken());
};

// -------------delete

export const deleteProductTypeApi = async (id) => {
  const endPoint = `/admin/product/type/${id}`;

  return await axios.delete(endPoint, setJwtToken());
};

// -------------add product type

export const addProductTypeApi = async (data) => {
  const endPoint = `/admin/product/type`;

  return await axios.post(endPoint, data, setJwtToken());
};

// -------------Edit product type

export const editProductTypeApi = async ({ id, data }) => {
  const endPoint = `/admin/product/type/${id}`;

  return await axios.put(endPoint, data, setJwtToken());
};

// -----get user details

export const getProductTypeDetailApi = async (id) => {
  const endPoint = `/admin/product/type/${id}`;

  return await axios.get(endPoint, setJwtToken());
};

// -----------master api call for product management

export const getMasterCategoryData = async (data) => {
  const endPoint = `/admin/master/category?${new URLSearchParams({
    ...data,
  })}`;

  return await axios.get(endPoint, setJwtToken());
};

export const getMasterSubCategoryData = async (data) => {
  const endPoint = `/admin/master/subcategory?${new URLSearchParams({
    ...data,
  })}`;

  return await axios.get(endPoint, setJwtToken());
};

export const getMasterBrandData = async () => {
  const endPoint = `/admin/master/brand`;

  return await axios.get(endPoint, setJwtToken());
};

export const getMasterProductType = async () => {
  const endPoint = `/admin/master/product/type`;

  return await axios.get(endPoint, setJwtToken());
};

export const getMasterUnitValue = async () => {
  const endPoint = `/admin/master/product/unit`;

  return await axios.get(endPoint, setJwtToken());
};
